import { CampaignType } from "config/CustomEnums";
import React from "react";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import CreateCouponCampaignRulePage from "./CreateCouponCampaignRulePage";
import CreateCampaignEarningPage from "./CreateCampaignEarningPage";

const CreateCampaignRulePage = ({
}) => {
  const {watch}= useFormContext();
  const campaignType = watch("campaignType")
  return <>
    {campaignType===CampaignType.couponsCampaign ? 
    <CreateCouponCampaignRulePage /> : <CreateCampaignEarningPage />
    }
  </>
}

const mapPropsToState = (state) => ({
});

export default  connect(mapPropsToState)(CreateCampaignRulePage);